import React, { forwardRef, type Ref } from 'react';
import { CustomThemeButton } from '@atlaskit/button';
import MoreIcon from '@atlaskit/icon/glyph/more';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';
import { pulseButtonTheme } from './styled';

type Props = {
	isOpen: boolean;
	isDisabled?: boolean;
	isLoading?: boolean;
	hasPulse: boolean;
	onClick?: () => void;
};

const DropdownTrigger = forwardRef(
	({ isOpen, isDisabled, isLoading, hasPulse, onClick }: Props, ref?: Ref<HTMLElement>) => {
		const { formatMessage } = useIntl();
		const intlTooltipText = formatMessage(messages.actions);
		const buttonTheme = hasPulse ? pulseButtonTheme : undefined;

		return (
			<Tooltip content={intlTooltipText} position="top">
				<CustomThemeButton
					testId="issue-meatball-menu.ui.dropdown-trigger.button"
					aria-label={intlTooltipText}
					aria-expanded={isOpen}
					aria-haspopup="true"
					isDisabled={isDisabled}
					isLoading={isLoading}
					appearance="subtle"
					spacing="default"
					iconBefore={<MoreIcon label="" size="medium" />}
					theme={buttonTheme}
					isSelected={isOpen}
					onClick={onClick}
					interactionName="auto-generated.issue-meatball-menu.ui.dropdown-trigger.button.button"
					ref={ref}
				/>
			</Tooltip>
		);
	},
);

DropdownTrigger.defaultProps = {
	hasPulse: false,
	isDisabled: false,
};

export default DropdownTrigger;
